import { render, staticRenderFns } from "./TodoFilters.vue?vue&type=template&id=04156554&scoped=true&"
import script from "./TodoFilters.vue?vue&type=script&lang=js&"
export * from "./TodoFilters.vue?vue&type=script&lang=js&"
import style0 from "./TodoFilters.vue?vue&type=style&index=0&id=04156554&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04156554",
  null
  
)

export default component.exports